/**
 * 添加开票订单抽屉
 */
import React, { useEffect, useRef, memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { message, Spin, Button, Table } from 'antd';
import intl from 'react-intl-universal';
import usePortalDrawer, { DrawerHeader, DrawerFooter } from '@/components/PortalDrawer';
// import usePortalConfirm from '@/components/PortalConfirm';
// import PortalLoading from '@/components/PortalLoading';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { addOrderList, initPageState } from '@/redux/actions/bill/invoice';
import { ReducerState, storeName } from '@/redux/reducers/bill/invoice';
import ThrottleButton from '@/components/Reservation/ThrottleButton';
import OtherOrder from './OtherOrder';
import RoomOrder from './RoomOrder';
import { InvoiceOrderTypeEnum } from '../../constant';
import * as helper from '../../helper';
import styles from './index.module.scss';

interface IConfig {
  type: InvoiceOrderTypeEnum; // 订单类型
  // onEnd?: (result: boolean) => void;
}

const stateSelector = (state: ReducerState) => {
  const { isInit, isLoading, orderList } = state;
  return { isInit, isLoading, orderList };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  addOrderList,
  callInitPage: initPageState,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

interface IProps extends MapStateProps, MapDispatchProps, IConfig {
  unmountNode: () => void;
}

const Index: React.FC<IProps> = ($$) => {
  const { type, unmountNode } = $$;

  // 房间&其他订单ref
  const roomRef = useRef<any>(null);
  const otherRef = useRef<any>(null);

  // 取消开发票
  const handleEditCancel = () => {
    unmountNode();
  };

  // 添加开票订单
  const handleSubmitClick = () => {
    // 添加的订单需要根据订单号进行去重
    let list = [];
    if (type === InvoiceOrderTypeEnum.room) {
      const { orderList } = roomRef.current.getOrders();
      // $$.addOrderList(orderList);
      list = orderList;
    } else {
      const { orderList } = otherRef.current.getOrders();
      // $$.addOrderList(orderList);
      list = orderList;
    }

    const newOrderList = [...$$.orderList];
    list.forEach((item) => {
      const index = newOrderList.findIndex((order) => order.orderNo === item.orderNo);
      if (index === -1) {
        newOrderList.push({
          ...item,
          invoiceAmount: item.availableAmt - item.invoicedAmt,
        });
      }
    });

    const orders = (newOrderList || []).map((item) => {
      return { orderNo: item.orderNo, orderType: item.orderType };
    });

    // 再次调用初始化得接口
    $$.callInitPage(() => {
      return helper.getInvoicesSummary(orders || []).catch((e) => {
        // unmountNode();
        throw e;
      });
    });
    unmountNode();
  };

  return (
    <>
      <DrawerHeader
        title={intl.get('bill_invoice_modal_add_invoice_order')}
        onClose={handleEditCancel}
      />
      <div className={styles.pageContainer}>
        <OtherOrder ref={otherRef} type={type} />
        <RoomOrder ref={roomRef} type={type} />
      </div>
      <DrawerFooter>
        <ThrottleButton
          type="primary"
          className={styles.submitBtn}
          onClick={handleSubmitClick}
          loading={$$.isLoading}
        >
          {intl.get('app_search_form_save_btn')}
        </ThrottleButton>
        <Button onClick={handleEditCancel}>{intl.get('app_confirm_cancel_btn')}</Button>
      </DrawerFooter>
    </>
  );
};

export default () =>
  usePortalDrawer<IConfig>(connect(mapStateToProps, mapDispatchToProps)(memo(Index)));
